0.35*W2+0.35*Y2+0.15*Z2+0.15*X2// For full API documentation, including code examples, visit https://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});